/// <reference types="temporal-spec/global" />

// Installs globalThis.Temporal only on engines that lack it natively. Imported here,
// not just in app entrypoints, so the install always precedes the capture below.
import 'temporal-polyfill/global';

/**
 * Platform Temporal implementation. Native where available, polyfilled otherwise.
 */
export import Temporal = globalThis.Temporal;
